import { matchPath } from 'react-router-dom'

export default function getActiveChatRequestId() {
  const match = matchPath(window.location.pathname, {
    path: '/:serviceUid/:chatRequestId/:restOfUrl',
  })

  return match ? match.params.chatRequestId : null
}
